"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.EyeOpenSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M18.9 15.1a3 3 0 01.1.9 3 3 0 11-3-3 3 3 0 01.9.1 1.5 1.5 0 00-.9 1.4 1.5 1.5 0 001.5 1.5 1.5 1.5 0 001.4-.9z"/><path d="M29.5 14.7c-12.5-15-23.4-4.3-27 0a2 2 0 000 2.6c12.5 15 23.4 4.3 27 0a2 2 0 000-2.6zM16 22a6 6 0 116-6 6 6 0 01-6 6z"/>';
var EyeOpenSVG = function EyeOpenSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.EyeOpenSVG = EyeOpenSVG;
EyeOpenSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(EyeOpenSVG);
exports.default = _default;